import { Controller } from "@hotwired/stimulus";
import ahoy from "ahoy.js";
import posthog from "posthog-js";

export default class extends Controller {
  static values = {
    shouldRecord: {
      type: Boolean,
      default: true,
    },
    event: String,
    namespace: String,
    details: Object,
  };

  connect() {
    this.businessId = document.querySelector(
      "meta[name='current_business_id']"
    )?.content;
    this.venueId = document.querySelector(
      "meta[name='current_venue_id']"
    )?.content;
  }

  record(event) {
    if (!this.shouldRecordValue) return;

    if (!this.eventValue) {
      console.warn("Ahoy event is not set");
      return;
    }

    if (!this.namespaceValue) {
      console.warn("Ahoy namespace is not set");
      return;
    }

    let details = this.detailsValue;

    if (this.element.tagName === "INPUT") {
      details = event.target.value;
    }

    const properties = {
      namespace: this.namespaceValue,
      details: {
        ...details,
        venue_id: this.venueId,
        business_id: this.businessId,
      },
    };

    // Track to Ahoy
    ahoy.track(this.eventValue, properties);

    // Track to PostHog
    posthog.capture(this.eventValue, properties);
  }
}
